var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslateHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    transform: "translate(-649.448 -425.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    transform: "translate(649 425)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1321",
    "data-name": "Rectangle 1321",
    width: 29,
    height: 16,
    rx: 1,
    transform: "translate(0.448 0.371)",
    fill: "#008bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12528",
    "data-name": "Path 12528",
    d: "M9.9,10.781A4.073,4.073,0,0,0,10.7,9H9.1A4.591,4.591,0,0,0,9.9,10.781Z",
    transform: "translate(-2.548 -2.047)",
    fill: "#4086ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192",
    transform: "translate(12.129 2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 2.374, 3.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_7",
    "data-name": "Polygon 7",
    d: "M1.542,0,3.083,1.85H0Z",
    transform: "matrix(-0.848, 0.53, -0.53, -0.848, 4.085, 3.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_239",
    "data-name": "Line 239",
    y2: 3.7,
    transform: "matrix(-0.848, 0.53, -0.53, -0.848, 1.961, 3.138)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    "data-name": "Group 2191",
    transform: "translate(6.599 8.673) rotate(120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_7-2",
    "data-name": "Polygon 7",
    d: "M1.542,0,3.083,1.85H0Z",
    transform: "matrix(-0.848, 0.53, -0.53, -0.848, 4.085, 3.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_239-2",
    "data-name": "Line 239",
    y2: 3.7,
    transform: "matrix(-0.848, 0.53, -0.53, -0.848, 1.961, 3.138)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12532",
    "data-name": "Path 12532",
    d: "M26.372,11.432H23.946l-.335,1.206H21.437q1.091-3.083,2.185-6.171c.262-.744.56-1.974,1.514-1.974.99,0,1.317,1.128,1.593,1.907l2.212,6.236H26.713l-.341-1.2ZM25.926,9.85l-.763-2.629L24.406,9.85Z",
    transform: "translate(-1.945 -0.31)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193",
    transform: "translate(2.901 2.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12529",
    "data-name": "Path 12529",
    d: "M11.994,11.25a.891.891,0,1,1,0,1.781,6.082,6.082,0,0,1-3.562-1.158A6.082,6.082,0,0,1,4.87,13.031a.891.891,0,0,1,0-1.781A4.627,4.627,0,0,0,7.1,10.626,6.7,6.7,0,0,1,5.849,7.687H4.87A.841.841,0,0,1,3.979,6.8a.841.841,0,0,1,.891-.891H7.541V4.125a.841.841,0,0,1,.891-.891.841.841,0,0,1,.891.891V5.906h2.672a.841.841,0,0,1,.891.891.841.841,0,0,1-.891.891h-.98a6.7,6.7,0,0,1-1.247,2.939A4.627,4.627,0,0,0,11.994,11.25Z",
    transform: "translate(-3.979 -3.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12528-2",
    "data-name": "Path 12528",
    d: "M9.9,10.781A4.073,4.073,0,0,0,10.7,9H9.1A4.591,4.591,0,0,0,9.9,10.781Z",
    transform: "translate(-5.449 -4.547)",
    fill: "#008bff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateHeader);
export default __webpack_public_path__ + "static/media/translate-header.bcc394053833774ed0fd2d97739413da.svg";
export { ForwardRef as ReactComponent };